import React, { useRef,useEffect,useState, useContext } from 'react'
import { Button } from 'primereact/button';     
import { InputTextarea } from 'primereact/inputtextarea';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { InputSwitch } from "primereact/inputswitch";
import { FileUpload } from 'primereact/fileupload';
import StepsIncident from '../steps/StepsIncident';
import { Divider } from 'primereact/divider';
import { InvalidError } from '../errors/InvalidError';
import { getAllRegions } from '../../api/axiosRegions';
import DataContext from '../../context/DataContext';
import { useTranslation } from 'react-i18next';
import { Toast } from 'primereact/toast';



        

const IncidentForm = (

  {
   
    fistNameReporter, setFistNameReporter,
    lastNameReporter, setLastNameReporter,
    selectedReporterRole, setSelectedReporterRole,
    phoneReporter, setPhoneReporter,
    emailReporter, setEmailReporter,
    selectedSexReporter, setSelectedSexReporter,
    incidentDescription, setIncidentDescription,
    selectedCountry, setSelectedCountry,
    selectedRegion, setSelectedRegion,
    selectedDistrict, setSelectedDistrict,
    selectedWard, setSelectedWard,
    street, setStreet,
    eventDate, setEventDate,
    selectedBroadCategory, setSelectedBroadCategory,
    selectedCategory, setSelectedCategory,
    selectedSubCategory, setSelectedSubCategory,
    selectedRight, setSelectedRight,
    stepsTaken, setStepsTaken,
    stepsDescription, setStepsDescription,
          
    fistNameVictim, setFistNameVictim,
    middleNameVictim, setMiddleNameVictim,
    lastNameVictim, setLastNameVictim,
    selectedSexVictim, setSelectSetSexVictim,
    selectedBirthDayVictim, setSelectedBirthDayVictim,
    selectedBirthMonthVictim, setSelectedBirthMonthVictim,
    birthYearVictim, setBirthYearVictim,
    phoneVictim, setPhoneVictim,
    selectedEducationLevelVictim, setESelectedEducationLevelVictim,
    selectedReligionVictim, setSelectedReligionVictim,
    selectedTribeVictim, setSelectedTribeVictim,
    childrenVictim, setChildrenVictim,
    selectedMaritalStatusVictim, setSelectedMaritalStatusVictim,
    selectedMarriageTypeVictim, setSelectedMarriageTypeVictim,
    selectedEmploymentStatusVictim, setSelectedEmploymentStatusVictim,
    selectedEmploymentSectorVictim, setSelectedEmploymentSectorVictim,
    isVictimVulnerable, setIsVictimVulnerable,
    selectedVulnerabilityVictim, setSelectedVulnerabilityVictim,
    isDisabled, setIsDisabled,
    selectedDisabilityVictim, setSelectedDisabilityVictim,
    fullNamePerpetrator, setFullNamePerpetrator,
    selectedSexPerpetrator, setSelectedSexPerpetrator,
    phonePerpetrator, setPhonePerpetrator,
    relationship, setRelationship,
    assitanceNeeded, setAssitanceNeeded,
    assitanceDescription, setAssitanceDescription,
    setFetcherror,
    handleFileUpload,
    incidentTitle, hadleSubmit,
    finalrolesArray, getCountryRegions,
    setRegions, countries,
    getRegionDistricts, setDistricts,
    regions, getDistrictWards,
    setWards, districts,
    wards, getBroadCategoryCategories,
    setCategories, getBroadCategoryRights,
    setRights, broadCategories,
    getCategorySubCategories, setSubCategories,
    categories, subCategories,
    rights, daysArray,
    monthsArray, educationLevels,
    religions, maritalStatuses,
    employmentStatuses, vulnerabilities,
    marriageTypes, employmentSectors,
    disabilities, fileUploadRef,
    validity, setValidity, monitorinitiated,
    handleSelectFile, handleRemoveFile,
    tribes, disabledField,
    setSelectedZone,
    zones
              
          

  }

 

) => {


  

  const [stepsactiveIndex, setStepsActiveIndex] = useState(0);
  const newIncidentTitle = incidentTitle ? incidentTitle : null
  const IncidentTitleClass = newIncidentTitle ? 'pt-4' : 'pt-0'
  
 
  const { t } = useTranslation();
  const { language } = useContext(DataContext);
  const toast = useRef(null);

  const [errors, setErrors] = useState({});
 

  const lowestYear = 1900;
  const currentYear = new Date().getFullYear();

  const handleFormValidation = (type) => {
    const updatedErrors = {};
    let error = false;
    
    let step0Error = false;
    let step1Error = false;
    let step2Error = false;
    
    const validateField = (fieldName, value, regex) => {
      if (!value) {
        updatedErrors[fieldName] = true;
        error = true;
         

      } else if (regex && !regex.test(value)) {
        updatedErrors[`invalid_${fieldName}`] = true;
        error = true;
         
      } else {
        updatedErrors[fieldName] = false;
        updatedErrors[`invalid_${fieldName}`] = false;
          
      }
    };

    const validateYear = (yearValue) => {
      if (!yearValue || isNaN(yearValue) || parseFloat(yearValue) < lowestYear || parseFloat(yearValue) > currentYear) {
        error = true;
        updatedErrors.birthYearVictim = true;
          
      } else {
        updatedErrors.birthYearVictim = false;
      }
    
    }

    const numberRegex = /^[0-9]+$/;
    
    // if (errors) {
    //   toast.current.show({ severity: 'error', summary: t('Incomplete Form'), detail: t('Some Mandatory Fields are Missing') , life: 3000 });
    // }

    const showStepToast = (stepIdx, formItem = false) => {
      if (stepIdx === -1) return;
      
      if (formItem) {
        toast.current?.show({
          severity: 'error',
          summary: t('Incomplete Form'),
          detail: `${t('Some Mandatory Fields are Missing')}`,
          life: 3500
        });
      } else {
        const stepNumber = stepIdx + 1;
        toast.current?.show({
          severity: 'error',
          summary: t('Incomplete Form'),
          detail: `${t('Some Mandatory Fields are Missing')} — ${t('Step')} ${stepNumber} :` + " " + (stepIdx === 0 ? t('Reporter and Incident Details') : stepIdx === 1 ? t('Profile of The Victim') : t('Papetrator Details and File Upload')),
          life: 3500
        });
      }
    };


    const countErrorKeys = () => Object.keys(updatedErrors).filter((k) => updatedErrors[k] === true).length;
    const initialErrorKeys = countErrorKeys();

    if (type === "steps") {

      if (stepsactiveIndex === 0) {
        const startingErrorKeys = countErrorKeys()
        validateField('incidentDescription', incidentDescription);
        validateField('selectedCountry', selectedCountry?.name);
        validateField('selectedRegion', selectedRegion?.name);
        validateField('selectedDistrict', selectedDistrict?.name);
        validateField('selectedWard', selectedWard?.name);
        validateField('street', street);
        validateField('eventDate', eventDate);
        validateField('selectedBroadCategory', selectedBroadCategory?.name);
        validateField('selectedCategory', selectedCategory?.name);
        validateField('selectedSubCategory', selectedSubCategory?.name);
        validateField('selectedRight', selectedRight?.name);
        // if (stepsTaken) { validateField('stepsDescription', stepsDescription); }
        validateField('stepsDescription', stepsDescription);
        // validateYear(year);
        
        step0Error = countErrorKeys() > startingErrorKeys;
      }
      
      if (stepsactiveIndex === 1) {
        const startingErrorKeys = countErrorKeys()
       
        validateField('fistNameVictim', fistNameVictim);
        validateField('lastNameVictim', lastNameVictim);
        validateField('selectedSexVictim', selectedSexVictim?.name);
        validateField('selectedBirthDayVictim', selectedBirthDayVictim?.day);
        validateField('selectedBirthMonthVictim', selectedBirthMonthVictim?.month);
        // validateField('birthYearVictim', birthYearVictim);
        validateYear(birthYearVictim);
        validateField('selectedEducationLevelVictim', selectedEducationLevelVictim?.name);
        validateField('selectedReligionVictim', selectedReligionVictim?.name);
        validateField('selectedTribeVictim', selectedTribeVictim?.name);
        validateField('selectedMaritalStatusVictim', selectedMaritalStatusVictim?.name);
  
        if (selectedMaritalStatusVictim?.name === "Married") {
          validateField('selectedMarriageTypeVictim', selectedMarriageTypeVictim?.name);
        }
  
        validateField('selectedEmploymentStatusVictim', selectedEmploymentStatusVictim?.name);
        if (selectedEmploymentStatusVictim?.name === "Employed" || selectedEmploymentStatusVictim?.name === "Self Employed") {
          validateField('selectedEmploymentSectorVictim', selectedEmploymentSectorVictim?.name);
        }
       
        if (isVictimVulnerable) {
          validateField('selectedVulnerabilityVictim', selectedVulnerabilityVictim?.name);
          if (selectedVulnerabilityVictim?.name === "PWDs" || selectedVulnerabilityVictim?.name === "PWDs GBV Victims") {
            validateField('selectedDisabilityVictim', selectedDisabilityVictim?.name);
          }
        }
        
        step1Error = countErrorKeys() > startingErrorKeys;
      }
  
      if (stepsactiveIndex === 2) {
        const startingErrorKeys = countErrorKeys()
        
        if (assitanceNeeded) { step2Error = validateField('assitanceDescription', assitanceDescription); }
        step2Error = countErrorKeys() > startingErrorKeys;
      }
      
    }

    

    // Decide lowest failing step
    const firstBadIdx = step0Error ? 0 : step1Error ? 1 : step2Error ? 2 : -1;
    // If any errors, toast and jump to lowest failing step
    if (firstBadIdx !== -1) {
      setStepsActiveIndex(firstBadIdx);
      showStepToast(firstBadIdx);
    }


   
    if (type === "form") {
        
      const startingErrorKeys = countErrorKeys()
      
      
      validateField('incidentDescription', incidentDescription);
      validateField('selectedCountry', selectedCountry?.name);
      validateField('selectedRegion', selectedRegion?.name);
      validateField('selectedDistrict', selectedDistrict?.name);
      validateField('selectedWard', selectedWard?.name);
      validateField('street', street);
      validateField('eventDate', eventDate);
      validateField('selectedBroadCategory', selectedBroadCategory?.name);
      validateField('selectedCategory', selectedCategory?.name);
      validateField('selectedSubCategory', selectedSubCategory?.name);
      validateField('selectedRight', selectedRight?.name);
      if (stepsTaken) { validateField('stepsDescription', stepsDescription); }

      validateField('fistNameVictim', fistNameVictim);
      validateField('lastNameVictim', lastNameVictim);
      validateField('selectedSexVictim', selectedSexVictim?.name);
      validateField('selectedBirthDayVictim', selectedBirthDayVictim?.day);
      validateField('selectedBirthMonthVictim', selectedBirthMonthVictim?.month);
      // validateField('birthYearVictim', birthYearVictim);
      validateYear(birthYearVictim);
      validateField('selectedEducationLevelVictim', selectedEducationLevelVictim?.name);
      validateField('selectedReligionVictim', selectedReligionVictim?.name);
      validateField('selectedTribeVictim', selectedTribeVictim?.name);
      validateField('selectedMaritalStatusVictim', selectedMaritalStatusVictim?.name);
  
      if (selectedMaritalStatusVictim?.name === "Married") {
        validateField('selectedMarriageTypeVictim', selectedMarriageTypeVictim?.name);
      }
  
      validateField('selectedEmploymentStatusVictim', selectedEmploymentStatusVictim?.name);
      if (selectedEmploymentStatusVictim?.name === "Employed" || selectedEmploymentStatusVictim?.name === "Self Employed") {
        validateField('selectedEmploymentSectorVictim', selectedEmploymentSectorVictim?.name);
      }
       
      if (isVictimVulnerable) {
        validateField('selectedVulnerabilityVictim', selectedVulnerabilityVictim?.name);
        if (selectedVulnerabilityVictim?.name === "PWDs" || selectedVulnerabilityVictim?.name === "PWDs GBV Victims") {
          validateField('selectedDisabilityVictim', selectedDisabilityVictim?.name);
        }
      }
      
      if (assitanceNeeded) { validateField('assitanceDescription', assitanceDescription); }
      
      const errorKeys = countErrorKeys()
      if (errorKeys > startingErrorKeys) {
        showStepToast(2, true);
      }
    }
    
    
    
    setErrors((err) => ({
      ...err,
      ...updatedErrors
    }));

    console.log("error on submit", error);
    console.log("updatedErrors", updatedErrors);
    return error;
};


const markRequiredFields =() => {
    return <span className='text-red-500 ml-1 font-bold'>*</span>
}



  return (
    

    <div className="card">
        <Toast ref={toast} />
      <Card title={newIncidentTitle} className={IncidentTitleClass}>
       
         <StepsIncident
                stepsactiveIndex={stepsactiveIndex}
                setStepsActiveIndex={setStepsActiveIndex}
          />
        
        <form action="" onSubmit={(e) => {
           e.preventDefault();
          const validationError = handleFormValidation("form");
          if (!validationError) { 
            hadleSubmit()
          } 
        }}
            >
               
            {stepsactiveIndex === 0 && <>
            
              
              <div className='mt-6'>
                <Divider align="start" type='solid' style={{ color: "black", width: '100%' }}>
                  <span className="p-tag text-xs mx-2">
                  <i className="pi pi-user" style={{ fontSize: '0.7rem', marginRight: '0.5rem' }}></i>
                    {t('Reporter Profile')}
                    </span>
                </Divider>
            </div>
            
              <Card>
                <div className='flex justify-content-between mb-4 w-full'>
                  <div className='w-4 pr-3' >
                  <label htmlFor="First Name" className="block text-900 font-medium mb-2">{t('First Name')} 
                    </label>
                    <InputText
                      className='w-full'
                      type="text"
                      placeholder={t('Enter First Name')}
                      value={fistNameReporter}
                      disabled={disabledField }
                      onChange={(e) => setFistNameReporter(e.target.value)}
                    />
                  </div>
                 
                  <div className='w-4 px-3'>
                  <label htmlFor="First Name" className="block text-900 font-medium mb-2">{t('Last Name')} 
                    </label>
                    <InputText
                      className='w-full'
                      type="text"
                      placeholder={t('Enter Last Name')}
                      value={lastNameReporter}
                      disabled={disabledField }
                      onChange={(e) => setLastNameReporter(e.target.value)}
                    />
                  </div>

                  <div className='w-4 pl-3'>
                  <label htmlFor="reporterSex" className="block text-900 font-medium mb-2">{t('Sex')} 
                    </label>
                    <Dropdown
                      value={selectedSexReporter}
                      onChange={(e) => setSelectedSexReporter(e.value)}
                      options={[{ id: 1, name: "MALE", namesw: "KIUME" }, { id: 2, name: "FEMALE", namesw: "KIKE" }]}
                      optionLabel={language === 'TZ' ? "namesw" : "name"}
                      placeholder={t('Select Sex')} showClear className="w-full"
                      disabled={disabledField}
                    /> 
                  </div>
              </div>

                <div className='flex justify-content-between mb-4 w-full'>
                  <div className='w-4 pr-3' >
                  <label htmlFor="phoneReporter" className="block text-900 font-medium mb-2">{t('Phone Number')}  
                    </label>
                    <InputText
                      className='w-full'
                      type="text"
                      placeholder={t('Phone Number')}
                      value={phoneReporter}
                      disabled={disabledField }
                      onChange={(e) => setPhoneReporter(e.target.value)}
                    />
                  </div>
                  <div className='w-4 px-3'>
                  <label htmlFor="emailReporter" className="block text-900 font-medium mb-2">{t('Email')} 
                    </label>
                    <InputText
                      className='w-full'
                      type="text"
                      placeholder={t('Enter Email')}
                      value={emailReporter}
                      disabled={disabledField }
                      onChange={(e) => setEmailReporter(e.target.value)}
                    />
                  </div>

                  <div className='w-4 pl-3'>
                  <label htmlFor="sex" className="block text-900 font-medium mb-2">{t('Role of the Reporter')} {markRequiredFields()}
                    </label>
                  <Dropdown
                    value={selectedReporterRole}
                    onChange={(e) => setSelectedReporterRole(e.value)}
                    options={finalrolesArray}
                    optionLabel="name"
                    disabled={disabledField }
                    placeholder={t('Select Role')} showClear className="w-full" /> 
                  </div>
              </div>
            </Card> 

                
              <div className='mt-6'>
                <Divider align="start" type='solid' style={{ color: "black", width: '100%' }}>
                  <span className="p-tag text-xs mx-2">
                  <i className="pi pi-envelope" style={{ fontSize: '0.7rem', marginRight: '0.5rem' }}></i>
                    {t('Incident Details')}</span>
                </Divider>
            </div>
            
              <Card>
              
              <div className='w-full mb-4'>
                <label htmlFor="sex" className="block text-900 font-medium mb-2">{t('Details of the Incident')} {markRequiredFields()}
                </label>
                <InputTextarea
                    className='w-full custom-textarea'
                    autoResize
                    // placeholder='Describe the Incident'
                    value={incidentDescription}
                    onChange={(e) => {
                    setIncidentDescription(e.target.value);
                    setErrors((prev) => ({ ...prev, incidentDescription: false }));
                  }}
                />
                {errors?.incidentDescription && <InvalidError errorMessage={t('Description is Required')} />}
              </div>
                
                    
              <div className='flex justify-content-between mb-4 w-full'>
                  <div className='w-4 pr-3' >
                        <label htmlFor="country" className="block text-900 font-medium mb-2">{t('Country')} {markRequiredFields()}</label>
                        <Dropdown
                          value={selectedCountry}
                          
                          onChange={(e) => {
                            setSelectedCountry(e.value);
                            getCountryRegions(setRegions, setFetcherror, e.value?.id);
                            setErrors((prev) => ({ ...prev, selectedCountry: false }));
                          }}
                          options={countries} optionLabel="name"
                          placeholder={t('Select Country')}
                          showClear
                          className="w-full"
                          disabled
                        />
                        {errors?.selectedCountry && <InvalidError errorMessage={t('Country is Required')} />}
                  </div>
                
                  <div className='w-4 px-3'>
                    <label htmlFor="region" className="block text-900 font-medium mb-2">{t('Region')} {markRequiredFields()}</label>
                    <Dropdown
                    value={selectedRegion}
                      onChange={(e) => {
                        setSelectedRegion(e.value);
                        getRegionDistricts(setDistricts, setFetcherror, e.value?.id);
                        setSelectedZone(zones?.find((z) => z.id === e.value?.zone_id));
                        setErrors((prev) => ({ ...prev, selectedRegion: false }));
                      }}
                      options={regions}
                      optionLabel="name"
                      placeholder={t('Select Region')}
                      showClear
                      className="w-full"
                    />
                     {errors?.selectedRegion && <InvalidError errorMessage={t('Region is Required')} />}
                  </div>

                  <div className='w-4 pl-3'>
                    <label htmlFor="First Name" className="block text-900 font-medium mb-2">{t('District')} {markRequiredFields()}</label>
                    <Dropdown value={selectedDistrict}
                      onChange={(e) => {
                        setSelectedDistrict(e.value);
                        getDistrictWards(setWards, setFetcherror, e.value?.id);
                        setErrors((prev) => ({ ...prev, selectedDistrict: false }));
                      }}
                      options={districts}
                      optionLabel="name"
                      placeholder={t('Select District')}
                      showClear
                      className="w-full"
                    />
                     {errors?.selectedDistrict && <InvalidError errorMessage={t('District is Required')} />}
                  </div>
              </div>

                <div className='flex justify-content-between mb-4 w-full'>
                  <div className='w-4 pr-3' >
                    <label htmlFor="phoneReporter" className="block text-900 font-medium mb-2">{t('Ward')} {markRequiredFields()}</label>
                    <Dropdown value={selectedWard}
                    onChange={(e) => {
                      setSelectedWard(e.value);
                      setErrors((prev) => ({ ...prev, selectedWard: false }));
                    }}
                      options={wards}
                      optionLabel="name"
                      placeholder={t('Select Ward')}
                      showClear
                      className="w-full"
                    />
                   {errors?.selectedWard && <InvalidError errorMessage={t('Ward is Required')} />}
                </div>
                
                  <div className='w-4 px-3'>
                    <label htmlFor="steet" className="block text-900 font-medium mb-2">{t('Street')} {markRequiredFields()}</label>
                    <InputText
                      className='w-full'
                      type="text"
                      placeholder={t('Enter Street/Village')}
                      value={street}
                      onChange={(e) => {
                      setStreet(e.target.value);
                      setErrors((prev) => ({ ...prev, street: false }));
                    }}
                    />
                    {errors?.street && <InvalidError errorMessage={t('Street is Required')} />}
                  </div>

                  <div className='w-4 pl-3'>
                    <label htmlFor="First Name" className="block text-900 font-medium mb-2">{t('Date Of the Event')} {markRequiredFields()}</label>
                    <Calendar
                      value={eventDate}
                    onChange={(e) => {
                      setEventDate(e.value);
                      setErrors((prev) => ({ ...prev, eventDate: false }));
                    }}
                      className='w-full'
                      placeholder={t('Select Date')}
                    dateFormat='dd/mm/yy'
                    maxDate={new Date()}
                    />
                    {errors?.eventDate && <InvalidError errorMessage={t('Date is Required')} />}
                  </div>
              </div>
             </Card>

              <div className='mt-6'>
                <Divider align="start" type='solid' style={{ color: "black", width: '100%' }}>
                  <span className="p-tag text-xs mx-2">
                  <i className="pi pi-ticket" style={{ fontSize: '0.7rem', marginRight: '0.5rem' }}></i>
                    {t('Incident Cetegorization')}</span>
                </Divider>
              </div>
            
              <Card className='mb-6 '>
                  <div className='flex justify-content-between mb-4 w-full'>
                      <div className='w-4 pr-3' >
                        <label htmlFor="broadcategory" className="block text-900 font-medium mb-2">{t('Issue Broad Category')} {markRequiredFields()}</label>
                        <Dropdown
                          value={selectedBroadCategory}
                          onChange={(e) => {
                              setSelectedBroadCategory(e.value);
                              getBroadCategoryCategories(setCategories, setFetcherror, e.value?.id);
                              getBroadCategoryRights(setRights, setFetcherror, e.value?.id);
                              setErrors((prev) => ({ ...prev, selectedBroadCategory: false }));
                            }}
                          options={broadCategories}
                          optionLabel={language === 'TZ' ? "namesw" : "name"}
                          placeholder={t('Select Broad Category')}
                          showClear
                          className="w-full"
                        />
                        {errors?.selectedBroadCategory && <InvalidError errorMessage={t('BroadCategory is Required')} />}
                    </div>
                
                    <div className='w-4 px-3'>
                      <label htmlFor="category" className="block text-900 font-medium mb-2">{t('Issue Category')} {markRequiredFields()}</label>
                      <Dropdown
                        value={selectedCategory}
                        onChange={(e) => {
                            setSelectedCategory(e.value);
                            getCategorySubCategories(setSubCategories, setFetcherror, e.value?.id);
                            setErrors((prev) => ({ ...prev, selectedCategory: false }));
                        }}
                        options={categories}
                        optionLabel={language === 'TZ' ? "namesw" : "name"}
                        placeholder={t('Select Category')}
                        showClear
                        className="w-full"
                      />
                      {errors?.selectedCategory && <InvalidError errorMessage={t('Category is Required')} />}
                    </div>

                    <div className='w-4 pl-3'>
                      <label htmlFor="subcategory" className="block text-900 font-medium mb-2">{t('Issue Sub Category')} {markRequiredFields()}</label>
                      <Dropdown
                        value={selectedSubCategory}
                        onChange={(e) => {
                          setSelectedSubCategory(e.value);
                          setErrors((prev) => ({ ...prev, selectedSubCategory: false }));
                        }}
                        options={subCategories}
                        optionLabel={language === 'TZ' ? "namesw" : "name"}
                        placeholder={t('Select SubCategory')}
                        showClear
                        className="w-full"
                      />
                      {errors?.selectedSubCategory && <InvalidError errorMessage={t('SubCategory is Required')} />}
                    </div>
                  </div>

                  <div className='flex justify-content-start mb-4 w-full'>
                    <div className='w-4 pr-3' >
                      <label htmlFor="right" className="block text-900 font-medium mb-2">{t('Right Violated')} {markRequiredFields()}</label>
                      <Dropdown
                        value={selectedRight}
                        onChange={(e) => {
                          setSelectedRight(e.value);
                          setErrors((prev) => ({ ...prev, selectedRight: false }));
                        }}
                        options={rights}
                        optionLabel={language === 'TZ' ? "namesw" : "name"}
                        placeholder={t('Select Violated Right')}
                        showClear
                        className="w-full"
                      />
                      {errors?.selectedRight && <InvalidError errorMessage={t('Right is Required')} />}
                    </div>

                    <div className='flex justify-content-center align-items-center w-2 px-3'>
                      {/* <InputSwitch checked={stepsTaken} onChange={(e) => setStepsTaken(e.value)} /> <span className='pl-3'>Steps Taken</span> */}
                    </div>

                  </div>
             

              {/* {stepsTaken && */}
                <>
                    <label htmlFor="stepsDescription" className="block text-900 font-medium mb-2">{markRequiredFields()}</label>
                    <InputTextarea
                      className='w-full h-8rem'
                      autoResize
                      placeholder={t('Describe Steps Taken')}
                      value={stepsDescription}
                      onChange={(e) => {
                        setStepsDescription(e.target.value);
                        setErrors((prev) => ({ ...prev, stepsDescription: false }));
                      }}
                     />
                {errors?.stepsDescription && <InvalidError errorMessage={t('Description is Required')} />}
                </>
                
              {/* } */}
              
              </Card>        
            </>}
           

          {stepsactiveIndex === 1 && <>
            
            <div className='mt-8'>
                <Divider align="start" type='solid' style={{ color: "black", width: '100%' }}>
                  <span className="p-tag text-xs mx-2">
                  <i className="pi pi-user" style={{ fontSize: '0.7rem', marginRight: '0.5rem' }}></i>
                    {t('Profile of the Victim')}</span>
                </Divider>
            </div>
            
            <Card >
                
                <div className='flex justify-content-between mb-4 w-full'>
                  <div className='w-4 pr-3' >
                    <label htmlFor="victimFirstName" className="block text-900 font-medium mb-2">{t('First Name')} {markRequiredFields()}</label>
                    <InputText
                      className='w-full'
                      type="text"
                      placeholder={t('Enter First Name')}
                      value={fistNameVictim}
                      onChange={(e) => {
                      setFistNameVictim(e.target.value);
                      setErrors((prev) => ({ ...prev, fistNameVictim: false }));
                    }}
                    />
                    {errors?.fistNameVictim && <InvalidError errorMessage={t('First Name is Required')} />}
                  </div>
                
                  <div className='w-4 px-3'>
                    <label htmlFor="victimMiddleName" className="block text-900 font-medium mb-2">{t('Middle Name')}</label>
                    <InputText
                      className='w-full'
                      type="text"
                      placeholder={t('Enter Middle Name')}
                      value={middleNameVictim}
                      onChange={(e) => setMiddleNameVictim(e.target.value)}
                    />
                  </div>

                  <div className='w-4 pl-3'>
                    <label htmlFor="victimLastName" className="block text-900 font-medium mb-2">{t('Last Name')} {markRequiredFields()}</label>
                    <InputText
                      className='w-full'
                      type="text"
                      placeholder={t('Enter Last Name')}
                      value={lastNameVictim}
                      onChange={(e) => {
                        setLastNameVictim(e.target.value);
                        setErrors((prev) => ({ ...prev, lastNameVictim: false }));
                      }}
                    />
                    {errors?.lastNameVictim && <InvalidError errorMessage={t('Last Name is Required')} />}
                  </div>

                  <div className='w-4 pl-3'>
                    <label htmlFor="victimSex" className="block text-900 font-medium mb-2">{t('Sex')} {markRequiredFields()}</label>
                  <Dropdown
                    value={selectedSexVictim}
                    onChange={(e) => {
                      setSelectSetSexVictim(e.value);
                      setErrors((prev) => ({ ...prev, selectedSexVictim: false }));
                    }}
                    options={[{ id: 1, name: "MALE", namesw:"KIUME" }, { id: 2, name: "FEMALE", namesw:"KIKE" }]}
                    optionLabel={language === 'TZ' ? "namesw" : "name"}
                    placeholder={t('Select Sex')}
                    showClear
                    className="w-full"
                  /> 
                  {errors?.selectedSexVictim && <InvalidError errorMessage={t('Sex is Required')} />}
                  </div>
              
                </div>

                <div className='flex justify-content-between mb-4 w-full'>
                  <div className='w-4 pr-3' >
                    <label htmlFor="First Name" className="block text-900 font-medium mb-2">{t('Birth Day')} {markRequiredFields()}</label>
                    <Dropdown
                      value={selectedBirthDayVictim}
                      onChange={(e) => {
                        setSelectedBirthDayVictim(e.value);
                        setErrors((prev) => ({ ...prev, selectedBirthDayVictim: false }));
                      }}
                      options={daysArray}
                      optionLabel="day"
                      placeholder={t('Select Birth Day')}
                      showClear
                      className="w-full"
                      />
                      {errors?.selectedBirthDayVictim && <InvalidError errorMessage={t('Date is Required')} />}
                  </div>
                
                  <div className='w-4 px-3'>
                    <label htmlFor="middleName" className="block text-900 font-medium mb-2">{t('Birth Month')} {markRequiredFields()}</label>
                    <Dropdown
                      value={selectedBirthMonthVictim}
                      onChange={(e) => {
                        setSelectedBirthMonthVictim(e.value);
                        setErrors((prev) => ({ ...prev, selectedBirthMonthVictim: false }));
                      }}
                      options={monthsArray}
                      optionLabel="month"
                      placeholder={t('Select Birth Month')}
                      showClear
                      className="w-full"
                    />
                    {errors?.selectedBirthMonthVictim && <InvalidError errorMessage={t('Month is Required')} />}
                  </div>

                  <div className='w-4 pl-3'>
                    <label htmlFor="Birth Year" className="block text-900 font-medium mb-2">{t('Birth Year')} {markRequiredFields()}</label>
                    <InputText
                      className='w-full'
                      type="text"
                      placeholder={t('Enter Birth Year')}
                      value={birthYearVictim}
                      onChange={(e) => {
                      setBirthYearVictim(e.target.value);
                        setErrors((prev) => ({ ...prev, birthYearVictim: (!e.target.value || isNaN(e.target.value) || parseFloat(e.target.value) < lowestYear || parseFloat(e.target.value) > currentYear) ? true : false }));
                        console.log("ERRORS:",errors);
                    }}
                    />
                    {/* {errors?.birthYearVictim && <InvalidError errorMessage={t('Year is Required')} />} */}
                    {errors?.birthYearVictim && !birthYearVictim && <InvalidError errorMessage={t('Year is Required')} />}
                    {errors?.birthYearVictim && birthYearVictim && ( isNaN(birthYearVictim) || parseFloat(birthYearVictim) <lowestYear || parseFloat(birthYearVictim) > currentYear ) && <InvalidError errorMessage={t('Invalid Year must not exceed current Year and not below 1900')} />}
                  </div>

                  <div className='w-4 pl-3'>
                    <label htmlFor="sex" className="block text-900 font-medium mb-2">{t('Phone/Mobile')}</label>
                    <InputText
                      className='w-full'
                      type="text"
                      placeholder={t('Enter Phone No. e.g 0754123456')}
                      value={phoneVictim}
                      onChange={(e) => setPhoneVictim(e.target.value)}
                    />
                  </div>
              
              </div>
            </Card>

              <div className='my-6'>
                <Divider align="start" type='solid' style={{ color: "black", width: '100%' }}>
                </Divider>
            </div>


            <Card className='mb-6'>
                <div className='flex justify-content-between mb-4 w-full'>
                  <div className='w-4 pr-3' >
                    <label htmlFor="First Name" className="block text-900 font-medium mb-2">{t('Education Level')} {markRequiredFields()}</label>
                    <Dropdown
                      value={selectedEducationLevelVictim}
                      onChange={(e) => {
                        setESelectedEducationLevelVictim(e.value);
                        setErrors((prev) => ({ ...prev, selectedEducationLevelVictim: false }));
                      }}
                      options={educationLevels}
                      optionLabel={language === 'TZ' ? "namesw" : "name"}
                      placeholder={t('Select Education Level')}
                      showClear
                      className="w-full"
                    />
                    {errors?.selectedEducationLevelVictim && <InvalidError errorMessage={t('Education is Required')} />}
                  </div>
                  <div className='w-4 px-3'>
                    <label htmlFor="middleName" className="block text-900 font-medium mb-2">{t('Religion')} {markRequiredFields()}</label>
                    <Dropdown
                      value={selectedReligionVictim}
                      onChange={(e) => {
                        setSelectedReligionVictim(e.value);
                        setErrors((prev) => ({ ...prev, selectedReligionVictim: false }));
                      }}
                      options={religions}
                      optionLabel={language === 'TZ' ? "namesw" : "name"}
                      placeholder={t('Select Religion')}
                      showClear
                      className="w-full"
                    />
                    {errors?.selectedReligionVictim && <InvalidError errorMessage={t('Religion is Required')} />}
                  </div>

                  <div className='w-4 pl-3'>
                    <label htmlFor="First Name" className="block text-900 font-medium mb-2">{t('Tribe')} {markRequiredFields()}</label>
                    <Dropdown
                      value={selectedTribeVictim}
                      onChange={(e) => {
                        setSelectedTribeVictim(e.value);
                        setErrors((prev) => ({ ...prev, selectedTribeVictim: false }));
                      }}
                      options={tribes}
                      optionLabel="name"
                      placeholder={t('Select Tribe')}
                      showClear
                      className="w-full"
                    />
                    {errors?.selectedTribeVictim && <InvalidError errorMessage={t('Tribe is Required')} />}
                  </div>

                  <div className='w-4 pl-3'>
                    <label htmlFor="sex" className="block text-900 font-medium mb-2">{t('Number of Children')}</label>
                    <InputText
                      className='w-full'
                      type="text"
                      placeholder={t('Enter Number of Children')}
                      value={childrenVictim}
                      onChange={(e) => setChildrenVictim(e.target.value)}
                    />
                  </div>
                  
                </div>

                <div className='flex justify-content-start mb-4 w-full'>
                  <div className='w-4 pr-3' >
                    <label htmlFor="First Name" className="block text-900 font-medium mb-2">{t('Marital Status')} {markRequiredFields()}</label>
                    <Dropdown
                      value={selectedMaritalStatusVictim}
                      onChange={(e) => {
                        setSelectedMaritalStatusVictim(e.value);
                        setErrors((prev) => ({ ...prev, selectedMaritalStatusVictim: false }));
                      }}
                      options={maritalStatuses}
                      optionLabel={language === 'TZ' ? "namesw" : "name"}
                      placeholder={t('Select Marital Status')}
                      showClear
                      className="w-full"
                    />
                    {errors?.selectedMaritalStatusVictim && <InvalidError errorMessage={t('Marital Status is Required')} />}
                </div>
                
                  <div className='w-4 px-3'>
                    <label htmlFor="middleName" className="block text-900 font-medium mb-2">{t('Employment Status')} {markRequiredFields()}</label>
                    <Dropdown
                      value={selectedEmploymentStatusVictim}
                      onChange={(e) => {
                        setSelectedEmploymentStatusVictim(e.value);
                        setErrors((prev) => ({ ...prev, selectedEmploymentStatusVictim: false }));
                      }}
                      options={employmentStatuses} optionLabel={language === 'TZ' ? "namesw" : "name"}
                      placeholder={t('Select Employment Status')} showClear className="w-full"
                    />
                    {errors?.selectedMaritalStatusVictim && <InvalidError errorMessage={t('Employment Status is Required')} />}
                </div>
                
                  <div className='flex justify-content-center align-items-center w-4 px-3'>
                    <InputSwitch checked={isVictimVulnerable} onChange={(e) => setIsVictimVulnerable(e.value)} /> <span className='pl-3'>{t('Is Victim Vulnerable?')}</span>
                  </div>

                  {isVictimVulnerable && <div className='w-4 pl-3'>
                    <label htmlFor="First Name" className="block text-900 font-medium mb-2">{t('Vulnerability')} {markRequiredFields()}</label>
                  <Dropdown
                    value={selectedVulnerabilityVictim}
                    onChange={(e) => {
                      setSelectedVulnerabilityVictim(e.value);
                      setErrors((prev) => ({ ...prev, selectedVulnerabilityVictim: false }));
                    }}
                    options={vulnerabilities} optionLabel={language === 'TZ' ? "namesw" : "name"}
                    placeholder={t('Select Vulnerability')}
                    showClear
                    className="w-full" />
                    {errors?.selectedVulnerabilityVictim && <InvalidError errorMessage={t('Vulnerability is Required')} />}
                  </div>
                  }{!isVictimVulnerable && <div className='w-4 pl-3'></div>}

                </div>

                
                <div className='flex justify-content-start mb-6 w-full'>
                
                    <div className='w-4 pr-3'>
                        {(selectedMaritalStatusVictim?.name === "Married") ?  (<div className='w-full'>
                                <label htmlFor="First Name" className="block text-900 font-medium mb-2">{t('Marriage Type')} {markRequiredFields()}</label>
                                <Dropdown
                                  value={selectedMarriageTypeVictim}
                                  onChange={(e) => {
                                    setSelectedMarriageTypeVictim(e.value);
                                    setErrors((prev) => ({ ...prev, selectedMarriageTypeVictim: false }));
                                  }}
                                  options={marriageTypes} optionLabel={language === 'TZ' ? "namesw" : "name"}
                                  placeholder={t('Select Marriage Type')} showClear className="w-full"
                                />
                                {errors?.selectedMarriageTypeVictim && <InvalidError errorMessage={t('Marriage Type is Required')} />}
                    </div>):
                      (<div className='full'></div>)}
                    </div>

                    <div className='w-4 px-3'>
                        {(selectedEmploymentStatusVictim?.name === "Employed"  || selectedEmploymentStatusVictim?.name === "Self Employed") && <div className='full'>
                            <label htmlFor="First Name" className="block text-900 font-medium mb-2">{t('Employment Sector')} {markRequiredFields()}</label>
                            <Dropdown
                              value={selectedEmploymentSectorVictim}
                              onChange={(e) => {
                                setSelectedEmploymentSectorVictim(e.value);
                                setErrors((prev) => ({ ...prev, selectedEmploymentSectorVictim: false }));
                              }}
                                      options={employmentSectors} optionLabel={language === 'TZ' ? "namesw" : "name"}
                              placeholder={t('Select Tribe')} showClear className="w-full"
                            />
                            {errors?.selectedEmploymentSectorVictim && <InvalidError errorMessage={t('Employment Sector is Required')} />}
                          </div>
                        }{(selectedEmploymentStatusVictim?.name === "Employed"  || selectedEmploymentStatusVictim?.name === "Self Employed") && <div className='full'></div>}
                     </div>   
                    
                     <div className='w-4 pl-3'>
                        {(selectedVulnerabilityVictim?.name === "PWDs" || selectedVulnerabilityVictim?.name === "PWDs GBV Victims") && <div >
                            <label htmlFor="First Name" className="block text-900 font-medium mb-2">{t('Disability')} {markRequiredFields()}</label>
                            <Dropdown
                              value={selectedDisabilityVictim}
                              onChange={(e) => {
                                setSelectedDisabilityVictim(e.value);
                                setErrors((prev) => ({ ...prev, selectedDisabilityVictim: false }));
                              }}
                              options={disabilities}
                              optionLabel={language === 'TZ' ? "namesw" : "name"}
                              placeholder={t('Select Disability')}
                              showClear
                              className="w-full"
                            />
                            {errors?.selectedDisabilityVictim && <InvalidError errorMessage={t('Disability is Required')} />}
                          </div>
                        }{!(selectedVulnerabilityVictim?.name === "PWDs" || selectedVulnerabilityVictim?.name === "PWDs GBV Victims")&& <div ></div>}
                    </div>
                
                        <div className='w-4 pl-3'></div>

              </div>
              
              </Card>

              </>}

          {stepsactiveIndex === 2 && <>
            

            <div className='mt-8'>
                <Divider align="start" type='solid' style={{ color: "black", width: '100%' }}>
                  <span className="p-tag text-xs mx-2">
                  <i className="pi pi-user" style={{ fontSize: '0.7rem', marginRight: '0.5rem' }}></i>
                    {t('Perpetrator Details')}</span>
                </Divider>
            </div>
            <Card>
                <div className='flex justify-content-between mb-4 w-full'>
                  <div className='w-6 pr-3' >
                    <label htmlFor="" className="block text-900 font-medium mb-2">{t('Full Name of Perpetrator')}</label>
                    <InputText
                      className='w-full'
                      type="text"
                      placeholder={t('Enter Full Name of the Perpetrator')}
                      value={fullNamePerpetrator}
                      onChange={(e) => setFullNamePerpetrator(e.target.value)}
                    />
                  </div>
               
                  <div className='w-4 px-3' >
                    <label htmlFor="phoneReporter" className="block text-900 font-medium mb-2">{t('Perpetrator Phone Number')}</label>
                    <InputText
                      className='w-full'
                      type="text"
                      placeholder={t('Phone Number')}
                      value={phonePerpetrator}
                      onChange={(e) => setPhonePerpetrator(e.target.value)}
                    />
                  </div>
                  <div className='w-4 pl-3'>
                    <label htmlFor="sex" className="block text-900 font-medium mb-2">{t('Sex')}</label>
                    <Dropdown value={selectedSexPerpetrator} onChange={(e) => setSelectedSexPerpetrator(e.value)}
                      options={[{ id: 1, name: "MALE", namesw:"KIUME" }, { id: 2, name: "FEMALE", namesw:"KIKE" }]} optionLabel={language === 'TZ' ? "namesw" : "name"}
                      placeholder={t('Select Sex')} showClear className="w-full" /> 
                  </div>
                </div>

                <div className='flex justify-content-between mb-4 w-full'>
                  <div className='w-4 pr-3' >
                    <label htmlFor="phoneReporter" className="block text-900 font-medium mb-2">{t('Relationship with Victim')}</label>
                    <InputText
                      className='w-full'
                      type="text"
                      placeholder={t('e.g Uncle,Husband Etc')}
                      value={relationship}
                      onChange={(e) => setRelationship(e.target.value)}
                    />
                  </div>
                  <div className='flex justify-content-center align-items-center w-4 px-3'>
                    <InputSwitch checked={assitanceNeeded} onChange={(e) => setAssitanceNeeded(e.value)} /> <span className='pl-3'>{t('Is Assistance Needed?')} {markRequiredFields()}</span>
                  </div>

                <div className='w-4 px-3'></div>
                {monitorinitiated && <div className='w-4 px-3'></div>}
                {!monitorinitiated &&
                  <div className=' flex justify-content-center align-items-center  w-4 pr-3'>
                    <InputSwitch checked={validity} onChange={(e) => setValidity(e.value)} /> <span className='pl-3'>{ validity? t('Is Valid') :t('Is Invalid')}</span>
                  </div> }
                  
                </div>
                
                  
              {assitanceNeeded &&
                <>
                  <label htmlFor="assitanceDescription" className="block text-900 font-medium mb-2">{t('Description of  the Required Assistance')} {markRequiredFields()}</label>
                  <InputTextarea
                  className='w-full h-8rem mb-4 '
                  autoResize
                  // placeholder="Describe the Required Assistance"
                  value={assitanceDescription}
                  onChange={(e) => {
                    setAssitanceDescription(e.target.value);
                    setErrors((prev) => ({ ...prev, assitanceDescription: false }));
                }}
                />
                {errors?.assitanceDescription && <InvalidError errorMessage={t('Description of Assistance is Required')} />}
                </>}
            </Card>
            

            <div className='mt-8'>
                <Divider align="start" type='solid' style={{ color: "black", width: '100%' }}>
                  <span className="p-tag text-xs mx-2">
                  <i className="pi pi-clip" style={{ fontSize: '0.7rem', marginRight: '0.5rem' }}></i>
                  {t('Files Upload')}</span>
                </Divider>
            </div>

            <Card className='mb-6'>
                <div className='flex justify-content-start mb-4  w-full'>
                  <div className='w-full' >
                    <label htmlFor="advanceFileUpload" className="block text-900 font-medium mb-2 mt-4"></label>
                    
                  <FileUpload
                     ref={fileUploadRef}
                     name="fileUpload"
                      id="advanceFileUpload"
                      multiple
                      customUpload="true"
                      accept="image/*,audio/*,.pdf,.doc,.docx"
                      maxFileSize={5000000}
                      uploadHandler={handleFileUpload}
                      onSelect={handleSelectFile}
                      onRemove={ handleRemoveFile}
                      emptyTemplate={
                        <p className="m-0 text-center" ><i className="pi pi-upload" style={{ fontSize: '1rem' }}></i> {t('Drag and drop files to here  or Click on the choose button to upload.')}</p>}
                  />
              
                  </div>

                </div>
                </Card>
                          
              </>}



                  <span className='flex flex-row justify-content-end'>
                    
                      {stepsactiveIndex === 2 &&
                          <Button
                            label={t('Submit')}
                            role='submit'
                            icon="pi pi-check"
                            className=""
                            
                      
                          />
                      }     
                    
                  </span>
            </form>

            <div className='flex flex-row justify-content-end'>
            
                {stepsactiveIndex === 0 &&
                  <Button
                  icon="pi pi-forward"
                  label={t('Next')}
                  outlined
                  iconPos="right"
                  className="ml-3"
            onClick={() => {
              const validationError = handleFormValidation("steps");
              if (!validationError) { 
                setStepsActiveIndex(1)
              }
            }}
                  />
                }   
                

          {stepsactiveIndex === 1 &&
                    
            <Button
              icon="pi pi-forward"
              label={t('Next')}
              outlined
              iconPos="right"
              className="ml-3"
              onClick={() => {
              const validationError = handleFormValidation("steps");
              if (!validationError) { 
                setStepsActiveIndex(2)
              }
               }}
                      />
                   
                }
            </div>
            
        </Card>
      </div>
  )
}

export default IncidentForm